import { Button } from '@/components/ui/button';
import { Link, useLocation } from '@tanstack/react-router';
import { Puzzle } from 'lucide-react';

export default function NotFound() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="space-y-3 text-center">
        <Puzzle className="text-muted-foreground mx-auto" size={32} />
        <p className="text-muted-foreground text-sm">
          Nothing to show at <code className="text-xs">{location.pathname}</code>
        </p>
        <Link to={isAdmin ? '/admin' : '/'}>
          <Button size="sm">{isAdmin ? 'Back to Enrich Admin' : 'Back to Enrich'}</Button>
        </Link>
      </div>
    </div>
  );
}
